import { handleActions } from 'redux-actions';
import update from 'immutability-helper';
import { LOGOUT, LOGOUT_SUCCESS, LOGOUT_ERROR } from '../type';

import { removeToken } from 'services/axios';
import { setDataToLocalStorage } from 'services/local-storage';
import { initialState } from './initialize-state';
import { StorageType } from 'common/enum';

const logoutReducer = handleActions(
  new Map([
    [
      LOGOUT,
      state => {
        return update(state, {
          loadingStatus: {
            logoutLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOGOUT_SUCCESS,
      state => {
        removeToken();
        setDataToLocalStorage(StorageType.AuthInfo, null);
        return update(state, {
          loadingStatus: {
            logoutLoading: { $set: false },
          },
          data: { $set: {} },
        });
      },
    ],
    [
      LOGOUT_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            logoutLoading: { $set: false },
          },
          error: { $set: action.payload },
        });
      },
    ],
  ]),
  initialState,
);

export default logoutReducer;
